<template>
    <div>
        <tech-template>
            <div class="account-container max-w-4xl mx-auto px-4 py-8">
            <h2 class="text-3xl font-bold text-gray-900 mb-8 flex items-center gap-2">
                <i class="fas fa-user-circle text-red-600"></i>
                Informations du Compte
            </h2>
            
            <div class="account-section mb-8 bg-white rounded-lg shadow-md p-6">
                <h3 class="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                <i class="fas fa-id-card text-red-600"></i>
                Données Personnelles
                </h3>
                <div class="info-grid grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="info-item">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Prénom:</label>
                    <span class="text-base text-gray-900">{{ $account.account.prenom }}</span>
                </div>
                <div class="info-item">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Nom:</label>
                    <span class="text-base text-gray-900">{{ $account.account.nom }}</span>
                </div>
                <div class="info-item">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Matricule:</label>
                    <span class="text-base text-gray-900">{{ $account.account.matricule }}</span>
                </div>
                <div class="info-item">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Email:</label>
                    <span class="text-base text-red-600">{{ $account.account.email }}</span>
                </div>
                </div>
            </div>

            <div class="account-section bg-white rounded-lg shadow-md p-6">
                <h3 class="text-xl font-semibold text-gray-800 mb-6 flex items-center gap-2">
                <i class="fas fa-building text-red-600"></i>
                Société
                </h3>
                <div class="info-grid grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="info-item">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Nom:</label>
                    <span class="text-base text-gray-900">{{ $account.account.societe.nom }}</span>
                </div>
                <div class="info-item">
                    <label class="block text-sm font-medium text-gray-600 mb-1">SIRET:</label>
                    <span class="text-base text-gray-900 font-mono">{{ $account.account.societe.siret }}</span>
                </div>
                <div class="info-item md:col-span-2">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Adresse:</label>
                    <span class="text-base text-gray-900">{{ $account.account.societe.adresse }}, {{ $account.account.societe.code_postal }} {{ $account.account.societe.ville }}</span>
                </div>
                <div class="info-item">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Téléphone:</label>
                    <span class="text-base text-gray-900">{{ $account.account.societe.tel }}</span>
                </div>
                <div class="info-item">
                    <label class="block text-sm font-medium text-gray-600 mb-1">Email:</label>
                    <span class="text-base text-red-600">{{ $account.account.societe.mail }}</span>
                </div>
                </div>
            </div>
            </div>
        </tech-template>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>